import * as React from "react";
import { useFieldProps } from "src/hooks/form/useField";
import { useReduxState } from "src/hooks/useRedux";
import { useStaticSelect } from "src/hooks/form/useSelect";
import masterDataProto from "src/Library/MasterDataType";

const useFF = <T>(props: useFieldProps<T>) => {
  const field = useStaticSelect<typeof FFs, T>(props);

  const FFs: typeof masterDataProto.dimensionData.FF = useReduxState([
    "masterData",
    "dimensionData",
    "FF",
  ]).value;
  React.useEffect(() => {
    if (!field.value) {
      field.setValue("");
    }
    field.setOptionsData(FFs, (data) => {
      return data?.map((el) => ({ key: el.id, label: el.name })) || [];
    });
  }, [FFs]);
  return field;
};

export default useFF;
